import zappy from "@zappy-ride/library.react.components";
import { ExternalLinksModal } from './ExternalLinksModal';

export * from "./ExternalLinksModal";

zappy.FactoryInstance.registerComponent(ExternalLinksModal);
